import type { WorkspacesViewerObservability } from '@amzn/dcv-web-sdk/workspaces';
import { CoreFactory } from '@/bridge/factory/CoreFactory';
import { InSessionFactory } from '@/bridge/factory/InSessionFactory';
import { makeViewerMetricsAdapter } from '@/bridge/metrics/viewerMetricsAdapter';

const viewerMetricsPublisher = makeViewerMetricsAdapter(
  CoreFactory.getMetrics(),
  CoreFactory.getLogger()
);

export interface LogUploaderSettings {
  isLogUploaderEnabledByUser: boolean;
  isLogUploaderEnabledAtDirectoryLevel: boolean;
  useDualStackIpv6: boolean;
}

// The log uploader, metrics publisher and sign-in timing Maxibon gives its
// viewer. The timing is the client's own session metric, as on /stream, so a
// reload of /agentic starts a new one rather than reusing the first launch's.
export const buildAgenticDcvObservability = (
  settings: LogUploaderSettings
): WorkspacesViewerObservability => ({
  logUploader: InSessionFactory.getWspLogUploader(settings),
  metricsPublisher: viewerMetricsPublisher,
  sessionTimedMetricSummary: CoreFactory.getMetrics()
    .embarkSessionMetric()
    .getTimedMetricOperationSummary(),
});
